import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2 } from 'lucide-react';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
export function HuntingGearBlinds() {
  useDocumentMeta('Hunting Gear & Blinds in Lake Benton, Minnesota | Kjergaard Sports', 'Prepare for hunting season with hunting blinds, field gear, and outdoor supplies at Kjergaard Sports in Lake Benton, Minnesota.');
  return <div data-id="element-551">
      <PageHero title="Hunting Gear & Blinds" image="https://cdn.magicpatterns.com/uploads/916kAQgnnbRYFKKSKvhkwD/hunting-apparel-gear.jpg" alt="Large in-store selection at Kjergaard Sports in Lake Benton, Minnesota" data-id="element-552" />

      <section className="py-20 bg-brand-offwhite" data-id="element-553">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-554">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-555">
            <div className="order-2 lg:order-1" data-id="element-556">
              <img src="https://cdn.magicpatterns.com/uploads/916kAQgnnbRYFKKSKvhkwD/hunting-apparel-gear.jpg" alt="Hunting gear selection at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-557" />
            </div>

            <div className="order-1 lg:order-2" data-id="element-558">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-559">
                Built Around Hunters
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-560">
                Hunters are the core of our business. Before you head into the
                woods, the marsh, or the fields, make Kjergaard Sports your
                first stop. We carry the durable, practical gear you need to
                stay concealed, comfortable, and ready when the moment counts.
              </p>
              <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-561">
                Our selection is curated for the realities of the Midwest
                outdoors. Whether you're preparing for deer season, chasing
                waterfowl, or calling in turkeys, we have the equipment to
                support your hunt.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-562">
            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-563">
              <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-564">
                Gear for the Field
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed mb-6" data-id="element-565">
                Apparel, boots, packs, and essential field gear designed to
                withstand harsh weather and rugged terrain.
              </p>
              <ul className="space-y-3" data-id="element-566">
                <li className="flex items-start" data-id="element-567">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-568" />
                  <span className="text-brand-charcoal/90" data-id="element-569">
                    Camouflage & Outerwear
                  </span>
                </li>
                <li className="flex items-start" data-id="element-570">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-571" />
                  <span className="text-brand-charcoal/90" data-id="element-572">
                    Hunting Packs & Bags
                  </span>
                </li>
                <li className="flex items-start" data-id="element-573">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-574" />
                  <span className="text-brand-charcoal/90" data-id="element-575">
                    Knives & Processing Tools
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-576">
              <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-577">
                Hunting Blinds
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed mb-6" data-id="element-578">
                Stay concealed and protected from the elements with our
                selection of ground blinds and elevated setups.
              </p>
              <ul className="space-y-3" data-id="element-579">
                <li className="flex items-start" data-id="element-580">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-581" />
                  <span className="text-brand-charcoal/90" data-id="element-582">
                    Pop-up Ground Blinds
                  </span>
                </li>
                <li className="flex items-start" data-id="element-583">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-584" />
                  <span className="text-brand-charcoal/90" data-id="element-585">
                    Waterfowl Layout Blinds
                  </span>
                </li>
                <li className="flex items-start" data-id="element-586">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-587" />
                  <span className="text-brand-charcoal/90" data-id="element-588">
                    Blind Chairs & Accessories
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-589">
              <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-590">
                Before the Season
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed mb-6" data-id="element-591">
                Everything you need to scout, prepare, and attract game before
                opening day arrives.
              </p>
              <ul className="space-y-3" data-id="element-592">
                <li className="flex items-start" data-id="element-593">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-594" />
                  <span className="text-brand-charcoal/90" data-id="element-595">Trail Cameras</span>
                </li>
                <li className="flex items-start" data-id="element-596">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-597" />
                  <span className="text-brand-charcoal/90" data-id="element-598">
                    Game Calls & Decoys
                  </span>
                </li>
                <li className="flex items-start" data-id="element-599">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-600" />
                  <span className="text-brand-charcoal/90" data-id="element-601">
                    Attractants & Scents
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-602">
            <div data-id="element-603">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-604">
                Expert Advice for Local Terrain
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-605">
                Our staff hunts the same fields, woods, and waters that you do.
                We can help you select the right gear based on local conditions,
                specific game, and your hunting style.
              </p>
            </div>
            <div data-id="element-606">
              <img src="https://cdn.magicpatterns.com/uploads/6uBKPbVFcv4swNygT9aBpc/mounted-rural-detail.jpg" alt="Rustic hunting details at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-607" />
            </div>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-608" />
    </div>;
}